import { defineMessages } from 'react-intl';

export default defineMessages({
    coverage: {
        id: 'ml.quoteandbind.paumbcoverages.coverage',
        defaultMessage: 'COVERAGE'
    },
    limits: {
        id: 'ml.quoteandbind.paumbcoverages.limits',
        defaultMessage: 'Limits'
    },
    limitsAndDed: {
        id: 'ml.quoteandbind.paumbcoverages.limitsAndDed',
        defaultMessage: 'Limits & Deductibles'
    },
    premium: {
        id: 'ml.quoteandbind.paumbcoverages.premium',
        defaultMessage: 'Premium'
    },
    monthlyPremium: {
        id: 'ml.quoteandbind.paumbcoverages.monthlyPremium',
        defaultMessage: 'Monthly Premium'
    }
});
